import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { ProcessorAppIcon2 as ProcessorAppIcon, ChronosMonochromeIcon, InfoSmallIcon } from './IconFactory';
export const PrintedHeader = React.memo(function PrintedHeader({ label, className = '' }) {
    return (_jsxs(PrintHeader, { className: `${className} c-print-header`, children: [_jsxs("div", { className: 'c-header-section', children: [_jsx(ChronosMonochromeIcon, { ...{ viewBox: "0 0 16 16" } }), _jsx(ProcessorAppIcon, { ...{ width: '1.5rem', height: '1.5rem' } })] }), _jsx("div", { className: "label", children: label })] }));
});
export const PrintNatalProlog = React.memo(function PrintNatalProlog({ text = 'prolog default', className = '' }) {
    return (_jsxs(PrintedProlog, { className: `${className}`, children: [_jsx(InfoSmallIcon, {}), _jsx("div", { className: "text", children: text })] }));
});
export const PrintHeader = styled.div `
  --color-sea: #16CAB9;

  display: none;
  justify-content: space-between;
  margin: 0 1rem;
  margin-bottom: 1.75rem;

  .c-header-section {
    display: flex;
    flex: 1;
    align-items: center;

    svg {
      width: 2.25rem;
      height: 2.25rem;
      color: #C3CCCA;
    }

    svg + svg {
      margin-left: 0.225rem;
      color: var(--color-sea);
    }
  }
  

  .label {
    display: flex;
    align-items: center;
    height: 2.25rem;
    padding: 0 1rem;
    border: 1pt solid var(--color-sea);
    border-radius: 2.438rem;

    font-size: 1.125rem;
    color: var(--color-sea);
  }

  @media print {
    display: flex;
  }
`;
export const PrintedTitle = styled.h1 `
  display: none;
  position: relative;
  margin: 0 1rem 0.875rem 1rem !important;
  font-size: 2.25rem;
  color: var(--text-primary);
  font-weight: 500;

  @media print {
    display: block;
  }
`;
export const PrintedFormData = styled.div `
  display: none;
  position: relative;
  margin: 0 1rem;
  margin-bottom: 1rem;

  font-size: 1rem;
  color: var(--text-third);

  @media print {
    display: flex;
  }
`;
export const PrintedProlog = styled.div `
  display: none;
  position: relative;
  align-items: flex-start;
  box-sizing: border-box;
  margin: 0 1rem;
  margin-bottom: 1.313rem;
  margin-top: 1rem;
  font-size: 1.125rem;

  & svg {
    position: absolute;
    width: 1.375rem;
    height: 1.375rem;
    left: -0.5rem;
    color: var(--text-third);
  }

  & .text {
    text-indent: 0.875rem;
    font-size: 1.125rem;
    color: var(--text-secondary);
    line-height: 1.5;
  }

  @media print {
    display: flex;
    
  }
`;
